import { supabase } from "@/shared/lib/supabase";

const FUNCTIONS_URL = import.meta.env.VITE_SUPABASE_FUNCTIONS_URL;

/**
 * App schema 쿼리 실행.
 * 항상 /v1/graphql/app (공개 앱 스키마) 경로 사용.
 * 인증된 세션이 있으면 Authorization 헤더에 토큰 포함하여 사용자 컨텍스트 전달.
 */
export async function executeRemote<T>(
  query: string,
  variables?: Record<string, unknown>,
): Promise<T> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (session?.access_token) {
    headers["Authorization"] = `Bearer ${session.access_token}`;
  }

  const res = await fetch(`${FUNCTIONS_URL}/graphql`, {
    method: "POST",
    headers,
    body: JSON.stringify({ path: "/v1/graphql/app", query, variables }),
  });

  const json = await res.json();
  if (json.errors?.length) throw new Error(json.errors[0].message);
  return (json.data ?? json) as T;
}
